// checking utilities
function isValidPhone(value) {
    return value.replace(/[^0-9]/g, '').substring(1).length === 10
}

function isValidDate(value) {
    const input = dayjs(value,'DD.MM.YYYY', 'ru', true)
    if(!input.isValid()) {
        return false
    }
    const now = dayjs()
    const max = dayjs().add(3, 'day')
    return value.length > 0 && input.isBetween(now, max, 'day', '[]')
}

function isValidBirthDate(value) {
    const formatedValue = dayjs(value,'DD.MM.YYYY', 'ru', true)
    if(!formatedValue.isValid()) {
        return false
    }
    const diff = dayjs().diff(formatedValue, 'year', true)
    return diff >= 18.42 && diff < 110.42
}

function isValidTime(value) {
    const timeArray = value.split(':')
    return timeArray[0] <= 24 && timeArray[1] <= 60
}

function isEmpty(value) {
    return value.length === 0
}

// end utilities

$('input[name="birthday"]').on({
    blur: function () {
        let $id = $(this).attr('id')
        if(isValidBirthDate($(this).val())) {
            $(`label[for="${$id}"].error-input-message`).hide()
            $(this).removeClass('input-error')
        }
    }
})

$('input[name="name"]').on({
    blur: function () {
        let $id = $(this).attr('id')
        if(!isEmpty($(this).val())) {
            $(`label[for="${$id}"].error-input-message`).hide()
            $(this).removeClass('input-error')
        }
    },
    input: function () {
        this.value = this.value.replace(/[^а-яё\s]/gi, '')
    }
})

$('input[name="phone"]').on({
    blur: function () {
        let $id = $(this).attr('id')
        if(isValidPhone($(this).val())) {
            $(`label[for="${$id}"].error-input-message`).hide()
            $(this).removeClass('input-error')
        }
    }
})

$('input[name="date"]').on({
    blur: function () {
        let $id = $(this).attr('id')
        if(isValidDate($(this).val())) {
            $(`label[for="${$id}"].error-input-message`).hide()
            $(this).removeClass('input-error')
        }
    }
})

$('input[name="time"]').on({
    blur: function () {
        let $id = $(this).attr('id')
        if(isValidTime($(this).val())) {
            $(`label[for="${$id}"].error-input-message`).hide()
            $(this).removeClass('input-error')
        }
    }
})

$('.cities-list').on({
    click: function () {
        $('.select-header').removeClass('input-error')
        $('label[for="inputCity"].error-input-message').hide()
    }
})

$('input[name="agreement"]').on({
    click: function () {
        let $id = `#${$(this).attr('id')}`

        if($(`${$id}`).prop('checked')) {
            $(this).removeClass('input-error')
            $(`label[for="${$(this).attr('id')}"]`).hide()
        }
    }
})

$('input[name="city-selected"]').on({
    blur: function () {
        if( $(this).val() === '') {
            $('.select-header').removeClass('city-error')
            $('label[for="inputCity"].error-input-message').hide()
        }
    }
})

$('input[name="birthday"], input[name="contract_num"]').on({
    input: function () {
        if($(this).val().length > 0) {
            $(this).removeClass('input-error')
            $(`label[for="${$(this).attr('id')}"]`).hide()
        }
    }
})

$("button[type='submit']").on({
    click: function (event) {
        event.preventDefault()

        const $form_id = $(this).attr('form')
        const $form = $(`form[id=${$form_id}]`);

        $($form).find('input').each(function () {
            if(this.name === 'name') {
                if(!isEmpty(this.value)) {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                } else {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                }
            }

            if(this.name === 'phone') {
                if(!isValidPhone(this.value)) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'contract_num') {
                const regexp = /\d{2}[А-я]{2}\d{12}/
                if(!regexp.test(this.value)) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'birthday') {
                if(!isValidBirthDate(this.value)) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'date') {
                if(!isValidDate(this.value)) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'time') {
                if(!isValidTime(this.value)) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'city-selected' && $('.cities').css('display') === 'block') {
                if(this.value === '') {
                    $('.select-header').addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $('.select-header').removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'agreement'){
                if(!$(this).prop('checked')) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if(this.name === 'sum') {
                let total_balance = Number(getCookie().total_balance)
                let inputed_sum = Number(this.value)

                if(inputed_sum < 100 || inputed_sum > total_balance) {
                    $(this).addClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).show()
                } else {
                    $(this).removeClass('input-error')
                    $(`label[for="${$(this).attr('id')}"]`).hide()
                }
            }

            if($('*').is('.input-error')) {
                event.stopImmediatePropagation()
            } else {
                $('.error-input-message').css(
                    {
                        'display': 'none'
                    })
            }
        })
    }
})

$("input[name='agreement']").click(function () {
    let radio = $(this);

    if(radio.data("was_checked") === true) {
        radio.prop("checked", true);
        radio.data("was_checked", false);
    } else {
        radio.data("was_checked", true);
        radio.prop("checked", false);
    }
    radio.next().toggle()
}).data("was_checked", true);

$('button.button-close').on({
    click: function () {
        $('input').each(function () {
            $(this).removeClass('input-error')
            $(this).val('')
        })

        $('label.error-input-message').each(function () {
            $(this).hide()
        })

    }
})

$('input[name="sum"]').on({
    input: function () {
        $(this).removeClass('input-error')
        $(`label[for="${$(this).attr('id')}"]`).hide()

        const max_input = Number(getCookie().total_balance)
        if(Number($(this).val()) > max_input) {
            $(this).val(`${max_input}`)
            $(`label.valid_sum_info`).removeClass('d-none')
                .text(`${max_input} - максимально допустимое значение`)
                .css('fontSize', '12px')
                .show()
        }
    }

})